import axios from 'axios';
import { createHeaders, onscreenTestHeaders } from './constants';

const hostname = window.location.hostname;
const stageHostnames = ["localhost", "finhub-stage.habilelabs.io"];

const baseMap = {
  "customer-test.finhub.habilelabs.io": "https://backend-test.finhub.habilelabs.io/api",
  "customer-v2.finhub.habilelabs.io": "https://endpoint-gateway.finhub.habilelabs.io/finhub-basic"
};
const apiMap = {
  "customer-test.finhub.habilelabs.io": "https://api-tejas-test.finhub.habilelabs.io",
  "customer-v2.finhub.habilelabs.io": "https://api-tejas.finhub.habilelabs.io"
};

 const baseURL = stageHostnames.includes(hostname)
 ?"https://endpoint-gateway-stage.finhub.habilelabs.io/finhub-basic"
  : baseMap[hostname] || "https://endpoint-gateway.finhub.habilelabs.io/finhub-basic";

  const onscreenApiUrl = stageHostnames.includes(hostname)
  ? "https://api-tejas-stage.finhub.habilelabs.io"
  : apiMap[hostname] || "https://api-gate.finhub.habilelabs.io";
  

export const digilockerService = {
  async getAuthUrl(aadhaarNumber) {
    const testHeaders = onscreenTestHeaders();
    console.log('DigiLocker getAuthUrl - Headers:', testHeaders);
    console.log('Session Storage apiKey:', sessionStorage.getItem('apiKey'));
    console.log('Session Storage userDetails:', sessionStorage.getItem('userDetails'));
    
    if (!testHeaders.api_key) {
      throw new Error('API key not found. Please ensure you are logged in and have valid API credentials.');
    }
    
    const response = await axios.post(`${onscreenApiUrl}/v1/digilocker-auth-url`, {
      aadhaarNumber: aadhaarNumber
    }, {
      headers: {
        ...createHeaders(),
        'api_key': testHeaders.api_key,
        'api_secret': testHeaders.api_secret,
      }
    });
    
    return response.data;
  },

  async getAccessToken(code, state, apiKey) {
    const response = await axios.post(`${baseURL}/access-token`, {
      code,
      state
    }, {
      headers: {
        ...createHeaders(),
        'Content-Type': 'application/json',
        'api-key': apiKey,
      }
    });
    
    return response.data;
  },

  async handleCallback(accessToken, state, apiKey) {
  
    const response = await axios.post(`${baseURL}/callback`, {
      state
    }, {
      headers: {
        ...createHeaders(),
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`,
        'api-key': apiKey,
      }
    });

    return response.data;
  },

  async getUserData(value, type) {
    const testHeaders = onscreenTestHeaders();
    console.log('DigiLocker getUserData - Headers:', testHeaders);
    console.log('Session Storage apiKey:', sessionStorage.getItem('apiKey'));
    console.log('Session Storage userDetails:', sessionStorage.getItem('userDetails'));
    
    if (!testHeaders.api_key || !testHeaders.api_secret) {
      throw new Error('API credentials not found. Please ensure you are logged in and have valid API credentials.');
    }
    
    try {
      const response = await axios.get(`${onscreenApiUrl}/v1/digilocker-verification`, {
        params: {
          [type]: value 
        },
        headers: {
          ...createHeaders(),
          'api_key': testHeaders.api_key,
          'api_secret': testHeaders.api_secret,
        }
      });
      
      return response.data;
    } catch (error) {
      console.error('DigiLocker getUserData error:', error.message);
      throw error;
    }
  },

  async checkDataExists(aadhaarNumber) {
    try {
      await this.getUserData(aadhaarNumber, "aadhaarNumber");
      return true;
    } catch (error) {
      return false;
    }
  }
};